import React, { useEffect, useState } from "react";
import {
  // LineChart,
  // Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Area,
  AreaChart,
} from "recharts";

const GraficoMedia = (props) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (props.dashboardJefe && props.dashboardJefe.distribucion_m) {
      let dataT = [];
      props.dashboardJefe.distribucion_m.map((item) => {
        dataT.push({
          Puntuacion_Media: item.Puntuacion_Media,
          "Evaluados": item.Personas,
          "Distribucion Normal": item.Distribucion_Normal,
        });
      });
      setData(dataT);
    }
  }, [props.dashboardJefe]);

  // const data = [
  //   {
  //     name: "20",
  //     Personas: 0,
  //     "Distribucion Normal": 0.1,
  //   },
  //   {
  //     name: "30",
  //     Personas: 3,
  //     "Distribucion Normal": 0.3,
  //   },
  //   {
  //     name: "40",
  //     Personas: 1,
  //     "Distribucion Normal": 0.5,
  //   },
  //   {
  //     name: "50",
  //     Personas: 0,
  //     "Distribucion Normal": 0.4,
  //   },
  //   {
  //     name: "60",
  //     Personas: 1,
  //     "Distribucion Normal": 0.2,
  //   },
  //   {
  //     name: "70",
  //     Personas: 0,
  //     "Distribucion Normal": 0.0,
  //   },
  //   {
  //     name: "80",
  //     Personas: 4,
  //     "Distribucion Normal": 0.0,
  //   },
  //   {
  //     name: "90",
  //     Personas: 1,
  //     "Distribucion Normal": 0.1,
  //   },
  // ];

  return (
    <>
      <div
        style={{ height: "400px", width: "900px" }}
        className="d-flex flex-wrap justify-content-center align-items-center"
      >
        <div style={{ height: "100%", width: "85%" }}>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              data={data}
              margin={{
                top: 5,
                right: 20,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                label={{
                  value: "Puntuación media por evaluado",
                  position: "insideBottom",
                  offset: 0,
                }}
                textAnchor={"end"}
                dataKey="Puntuacion_Media"
              />
              <YAxis
                label={{
                  value: "Número de evaluados",
                  angle: -90,
                  position: "inside",
                  dx: -10,
                }}
                yAxisId="left"
              />
              {/* <YAxis
                label={{
                  value: "Distribución media",
                  angle: -90,
                  position: "inside",
                  dx: -10,
                }}
                yAxisId="left"
              /> */}
              {/* <YAxis
                label={{
                  value: "Número de empleados",
                  angle: 90,
                  position: "inside",
                }}
                yAxisId="right"
                orientation="right"
              /> */}
              <Tooltip />
              <Legend layout="horizontal" verticalAlign="top" align="center" />
              {/* <Area
                yAxisId="left"
                type="monotone"
                dataKey="Distribucion Normal"
                stroke="rgba(4, 127, 243)"
                fill="rgba(4, 127, 243)"
                activeDot={{ r: 8 }}
              /> */}
              <Area
                yAxisId="left"
                dataKey="Evaluados"
                stroke="rgba(4, 127, 243)"
                fill="rgba(4, 127, 243)"
                activeDot={{ r: 8 }}
              />
              {/* <Area
                yAxisId="right"
                dataKey="Personas"
                stroke="rgba(243, 87, 4)"
                fill="rgba(243, 87, 4)"
              /> */}
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
};

export default GraficoMedia;
